import PropTypes from 'prop-types';
import React from 'react';
import getData from './getData';

/**
 *  Describe the component
 *
 */
function VehicleDetails(_ref) {
  let {
    inventory,
    searchLocation,
    baseUrl,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "vehicleDetailsSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(inventory, searchLocation, baseUrl))}`
    }
  }, rest));
}
export default VehicleDetails;